import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getListProhibitedItems(payload) {
    let checkNoticeProhibited = payload && payload.checkNoticeProhibited ? payload.checkNoticeProhibited : false
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_URL}/api/itemname/getallprohibitedkeyword?checkNoticeProhibited=${checkNoticeProhibited}`,
        headers: getApiHeader(),
        withCredentials: true,
        data: {},
    })
}

export function updateLastCheckedKeywordUser(payload) {
    let lastCheckedKeywordDT = payload && payload.lastestUpdateDTOrigin ? payload.lastestUpdateDTOrigin : null
    return axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_URL}/api/itemname/updatelastcheckedkeyworduser?lastCheckedKeywordDT=${lastCheckedKeywordDT}`,
        headers: getApiHeader(),
        withCredentials: true,
        data: {
            lastCheckedKeywordDT
        },
    })
}


// WEBPACK FOOTER //
// ./src/utils/prohibitedItems.js